module.exports = __webpack_public_path__ + "img/bachelor-automobiltechnik-inhalt-aufbau.66fd2a7b.jpg";